import ACTION_TYPES from 'constants/ACTION_TYPES';
import {SORTING_OPTIONS} from 'constants/COMMUNITY_STATUS';


const initialState = {
    answers: [],
    isLoadingAnswers: false,
    answersPerPage: 10,
    answersPage: 1,
    answersTotal: 0,
    answersTotalPages: 1,
    selectedAnswer: null,
    answersOrder: SORTING_OPTIONS[0].value,
    answersReelFilter: 'all',
    flagsSelectedAnswer: [],
    isLoadingFlags: false,
    flagsPerPage: 10,
    flagsPage: 1,
    flagsTotal: 0,
    flagsTotalPages: 1,
    flagsOrder: SORTING_OPTIONS[0].value,
    flagsStatus: 'all',
    files: [],
    isLoadingFiles: false,
    translations: [],
    translations_page: 1,
    translations_per_page: 10,
    translations_total: 0,
    translations_total_pages: 1,
    translations_is_loading: false,
    selectedTranslation: null,
};

function QuestionsReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.CS_FETCH_ANSWERS_PER_QUESTION_REQUEST: {
            return {
                ...state,
                isLoadingAnswers: true,
                
            };
        }
        case ACTION_TYPES.CS_FETCH_ANSWERS_PER_QUESTION_RESPONSE: {
            return {
                ...state,
                isLoadingAnswers: false,
                answers: action.data.list,
                answersTotal: action.data.total,
                answersTotalPages: action.data.total_pages,
                answersPage: action.data.page,
                answersPerPage: action.data.per_page,
            };
        }
        case ACTION_TYPES.CS_SELECT_QUESTION_ANSWER:{
            return {
                ...state,
                selectedAnswer: action.data,
            }
        }
        case ACTION_TYPES.CS_DELETE_ANSWER_RESPONSE: {
            return {
                ...state,
                selectedAnswer: null,
            }
        }
        case ACTION_TYPES.CS_SELECT_QUESTION_ANSWER_REEL_FILTER: {
            return {
                ...state,
                answersPage: 1,
                answersReelFilter: action.data,
            }
        }
        case ACTION_TYPES.CS_SELECT_QUESTION_ANSWER_ORDER_FILTER: {
            return {
                ...state,
                answersPage: 1,
                answersOrder: action.data,
            }
        }
        case ACTION_TYPES.CS_POST_ANSWER_RESPONSE: {
            return {
                ...state,
                selectedAnswer: action.data,
            };
        }
        case ACTION_TYPES.CS_FETCH_ANSWER_RESPONSE: {
            return {
                ...state,
                selectedAnswer: action.data,
            };
        }
        case ACTION_TYPES.CS_UPDATE_ANSWER_RESPONSE: {
            return {
                ...state,
                selectedAnswer: action.data,
            }
        }
        case ACTION_TYPES.CS_SELECT_ANSWER_FLAGS_ORDER_FILTER: {
            return{
                ...state,
                flagsOrder:action.data
            }
        }
        case ACTION_TYPES.CS_SELECT_ANSWER_FLAGS_STATUS_FILTER: {
            return {
                ...state,
                flagsPage: 1,
                flagsStatus: action.data,
            }
        }
        case ACTION_TYPES.CS_FETCH_ANSWER_FLAGS_RESPONSE:{
            return {
                ...state,
                isLoadingFlags: false,
                flagsSelectedAnswer: action.data.list,
                flagsTotal: action.data.total,
                flagsTotalPages: action.data.total_pages,
                flagsPage: action.data.page,
                flagsPerPage: action.data.per_page,
            };
        }
        case ACTION_TYPES.CS_UPDATE_ANSWER_FLAGS_REASON_RESPONSE: {
            return {
                ...state,
                flagsSelectedAnswer: {...state.flagsSelectedAnswer, ...action.data.results},
            };
        }
        case ACTION_TYPES.CS_FETCH_ANSWER_FILES_REQUEST: {
            return {
                ...state,
                isLoadingFiles: true,
            };
        }
        case ACTION_TYPES.CS_FETCH_ANSWER_FILES_RESPONSE: {
            return {
                ...state,
                files: action.data,
                isLoadingFiles: false,
            };
        }
        case ACTION_TYPES.CS_FETCH_ANSWER_TRANSLATIONS_REQUEST: {
            return {
                ...state,
                translations_is_loading: true,
            };
        }
        case ACTION_TYPES.CS_FETCH_ANSWER_TRANSLATIONS_RESPONSE: {
            return {
                ...state,
                translations: action.data.list,
                translations_page: action.data.page,
                translations_per_page: action.data.per_page,
                translations_total: action.data.total,
                translations_total_pages: action.data.total_pages,
                translations_is_loading: false,
            };
        }
        case ACTION_TYPES.CS_POST_ANSWER_TRANSLATION_RESPONSE:
        case ACTION_TYPES.CS_UPDATE_ANSWER_TRANSLATION_RESPONSE:
        case ACTION_TYPES.CS_SELECT_ANSWER_TRANSLATION: {
            return {
                ...state,
                selectedTranslation: action.data,
            };
        }
        default:
            return state;
    }
}

export default QuestionsReducer